import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const createCategoryInsert = createAsyncThunk('createCategoryInsert', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertCategory`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});



export const fetchCategoryData = createAsyncThunk('fetchCategoryData', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getPIlist`);
        return response.data;
    } catch (error) {
        throw error;
    }
});



export const fetchPINo = createAsyncThunk('fetchPINo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getbarPIno`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const deletePI = createAsyncThunk('deletePI', async (Ids) => {
    const {purId, clothId, pInfoId} = Ids;
    try {
        const response = await axios.get(`${baseUrl}?apicall=deletePI&purId=${purId}&clothId=${clothId}&pInfoId=${pInfoId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});




const categorySlice = createSlice({
    name: 'CategoryData',
    initialState: {
        isLoading: false,
        catgorylist: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchCategoryData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchCategoryData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.catgorylist = action.payload;
        });
        builder.addCase(fetchCategoryData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

      

    }
});

export default categorySlice.reducer;
